<div class="header_panel" id="routeStepsContent">
  
  <div *ngFor="let dateKey of getDateKeys()" class="date-card">
    <div class="date-header" (click)="toggleDateExpansion(dateKey)">
      <div class="section-header-background">
        <h3>{{ dateKey }}</h3>
        <button class="date-toggle-button" mat-icon-button>
          <mat-icon>{{ isDateExpanded(dateKey) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </div>
    </div>

    <div class="date-content" *ngIf="isDateExpanded(dateKey)">
      <div *ngFor="let group of groupedByDate.get(dateKey); let isLast = last" class="itemGroup">
      <div [id]="group.idGroup" 
           class="itemPanel group-container" 
           [ngClass]="group.typeStep == 'Apagado' ? 'cardApagado' : 'cardTrayecto'"  
           (click)="onClickGroup(group.idGroup)">
        
        <div class="group-left">
          <div class="icon-container">
            <img *ngIf="group.typeStep == 'Apagado'" class="imgDetail" src="/assets/img/parking.png" alt="Apagado">
            <img *ngIf="group.typeStep == 'Trayecto'" class="imgDetail" src="/assets/img/moving.png" alt="Trayecto">
            <img *ngIf="group.typeStep == 'TrayectoEngineer'" class="imgDetail" src="/assets/img/reporting.png" alt="TrayectoEngineer">
          </div>
          <div class="continuity-line" [class.hide-line]="isLast"></div>
        </div>

        <div class="group-center">
          <div class="titleStatus">{{getTypeStepLabel(group.typeStep)}} ({{group.idGroup}})</div>
          <div class="data-compartments">
            <div class="data-item">
              <mat-icon class="data-icon">timer</mat-icon>
              <span class="data-value">{{group.horaInicioGroup}}</span>
            </div>
            <div class="data-item">
              <mat-icon class="data-icon">{{ isPedestrianStep(group.typeStep) ? 'directions_walk' : 'directions_car' }}</mat-icon>
              <span class="data-value">{{group.sDistanceGroup}}</span>
            </div>
            <div class="data-item">
              <mat-icon class="data-icon">schedule</mat-icon>
              <span class="data-value">{{group.sElapsedGroup || 'N/A'}}</span>
            </div>
          </div>
        </div>

        <div class="group-right">
          <button class="group-button" mat-icon-button (click)="group.showDetails = !group.showDetails; $event.stopPropagation()">
            <mat-icon>{{ group.showDetails ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="group.showDetails">
        <div *ngFor="let detail of group.steps">
          <div class="itemSingle">
            <div class="itemPanelChild child-container" 
                 [ngClass]="detail.typeStep == 'Encendido' ? 'cardEncendido' : detail.typeStep == 'Moviendo' ? 'cardMoviendo' : 'cardApagado'" 
                 (click)="onClickStep(detail, group.idGroup)">
              
              <div class="child-left">
                <div class="icon-container">
                  <img *ngIf="detail.typeStep == 'Encendido'" class="imgDetail" src="/assets/img/starting.png" alt="Encendido">
                  <img *ngIf="detail.typeStep == 'Trayecto'" class="imgDetail" src="/assets/img/moving.png" alt="Trayecto">
                  <img *ngIf="detail.typeStep == 'TrayectoEngineer'" class="imgDetail" src="/assets/img/reporting.png" alt="TrayectoEngineer">
                  <img *ngIf="detail.typeStep == 'Apagado'" class="imgDetail" src="/assets/img/parking.png" alt="Apagado">
                </div>
              </div>

              <div class="child-center">
                <div class="titleStatus">{{detail.id}}. {{getTypeStepLabel(detail.typeStep)}}</div>
                <div *ngIf="detail.typeStep == 'Encendido' || detail.typeStep == 'Apagado'" class="titleDirection">{{detail.direction}}</div>
                <div class="child-data-compartments">
                  <div class="data-item">
                    <mat-icon class="data-icon">timer</mat-icon>
                    <span class="data-value">{{getTimePeriod(detail.sHoraInicial)}}</span>
                  </div>
                  <div class="data-item">
                    <mat-icon class="data-icon">{{ isPedestrianStep(detail.typeStep) ? 'directions_walk' : 'directions_car' }}</mat-icon>
                    <span class="data-value">{{detail.distance}} Km</span>
                  </div>
                  <div class="data-item">
                    <mat-icon class="data-icon">schedule</mat-icon>
                    <span class="data-value">{{detail.sElapsed}}</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>

</div>
